import mutations from './mutations'
import getters from './getters'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    accesstokenLine: '',
    isAuthenticated: 'true',
    profile: {},
    businessProfile: {
      id: null,
      session_token: '',
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      facebook_id: null,
      line_id: null,
      registered_date: null,
      last_login_date: null,
      remark: null,
      ref_index: null,
      active: false,
      cms_admin_id: null,
      is_verify: false,
      picture_url: null,
      name: '',
      packageType: 'free'
    },
    dataRegister: {
      first_name: null,
      last_name: null,
      phone: null,
      email: null,
      password: null,
      facebook_id: null,
      line_id: null,
      remark: null,
      ref_index: null
    }
  },
  mutations,
  getters,
  actions
}
